import {
  Mtds,
  TestTubeIcon,
  UploadIcon,
  IntersectThreeIcon,
  GearIcon
} from 'prove-common'
import { NavLink } from 'react-router'
import React from 'react'

export const SideBarLayout = () => {
  return (
    <>
      <Mtds.App.Toggle id={'mtds-app-toggle'} />
      <Mtds.App.Sidebar>
        <Mtds.App.Sticky as='menu'>
          <li>
            <Mtds.Button as={NavLink} data-tooltip='Samples' to='/samples'>
              <TestTubeIcon />
            </Mtds.Button>
          </li>
          <li>
            <Mtds.Button
              as={NavLink}
              data-tooltip='Upload reports'
              to='/upload-reports'
            >
              <UploadIcon />
            </Mtds.Button>
          </li>
          <li>
            <Mtds.Button
              as={NavLink}
              data-tooltip='Combinations'
              to='/combinations'
            >
              <IntersectThreeIcon />
            </Mtds.Button>
          </li>
          <li>
            <Mtds.Button as={NavLink} data-tooltip='Settings' to='/settings'>
              <GearIcon />
            </Mtds.Button>
          </li>
        </Mtds.App.Sticky>
      </Mtds.App.Sidebar>
    </>
  )
}
